import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import ChangePositionControlPanel from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import ChangePositionList from './components/ChangePositionList/ChangePositionList';
import AdditionalRestaurantsModal from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import ModalWindows from './components/ModalWindows/ModalWindows';
import BtnBlock from './components/BtnBlock';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeSubCategoryPositionContext,
	IChangeSubCategoryPositionContext,
} from '../../changeSubCategoryPositionState/changeSubCategoryPositionContext';
import style from './ChangeSubCategoryPosition.module.scss';

const ChangeSubCategoryPosition: React.FC = () => {
	const { positionsData, IDSelectedCategory } = useContext<IChangeSubCategoryPositionContext>(
		ChangeSubCategoryPositionContext,
	);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangeSubCategoryPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
					<AdditionalRestaurantsModal />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!IDSelectedCategory} />
			)}
			<NoFiltersChangePosition isVisible={!IDSelectedCategory} />
		</div>
	);
};

export default ChangeSubCategoryPosition;
